import axios from '../request.js';

export default {
    computed: {
        tournament: function () {
            let tournament = this.$store.state.tournament;
            return (tournament && tournament.id == this.$route.params.id ? tournament : null);
        }
    },

    watch: {
        '$route' (to, from) {
            if (to.params.id !== from.params.id) {
                this.loadTournament(to.params.id);
            }
        }
    },

    methods: {
        loadTournament(id) {
            this.$store.dispatch('loadTournament', id);
        },

        checkTournamentLoaded(id) {
            this.$store.dispatch('checkTournamentLoaded', id);
        },

        rescheduleMatches(scheduleConfig) {
            let vm = this;

            axios.post('/api/tournament/' + scheduleConfig.id + '/schedule', scheduleConfig)
                .then(function(response){
                    vm.$store.dispatch('tournamentEventsChanged', { tournamentId: scheduleConfig.id, events: response.data, stayOnPage: true });
                    vm.$forceUpdate();
                })
                .catch(function(){});
        }
    },

    created: function() {
        this.checkTournamentLoaded(this.$route.params.id);
    }
};
